import { Component, OnInit} from '@angular/core';
import { LocationService } from '../../../services/location.service';
import { ToastrService } from 'ngx-toastr';
import { UtilitiesService } from '../../../services/utilities.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SETTING_KEY_FOR_AUTO_CASHOUT, SETTING_KEY_FOR_EMAIL_OPTIONAL, SETTING_KEY_FOR_MULTI_CURRENCIES_INBOUND, SETTING_KEY_FOR_PHONE_NUMBER_OPTIONAL, SETTING_KEY_FOR_TOPAZ_SIGWEB } from 'src/app/shared/constants';
import { TranslateService } from '@ngx-translate/core';
import { InvalidMobileErrorService } from 'src/app/services/invlid-mobile-error.service';
import { BranchSettings } from 'src/app/models/branch-settings/BranchSettings';

@Component({
  selector: 'app-branch-management',
  templateUrl: './branch-management.component.html',
  styleUrls: ['./branch-management.component.scss']
})
export class BranchManagementComponent implements OnInit {
  branchDetails = {} as ILocationDetails;
  BusinessWeek = {};
  currencies = [];
  selectedVal;
  locationSettings: any[] = JSON.parse(sessionStorage.getItem('branchSettings'));
  isMultiCurrenciesForInbound = false;
  ForceDailyCashout = false;
  AllowTopazSigWeb = false;
  isMultiCurrenciesVisible = false;

  isPhoneOptionalForInbound = false;  
  isEmailOptionalForInbound = false;
  smallPackagingPrice;
  mediumPackagingPrice;
  largePackagingPrice; 


  initialSettings: BranchSettings;
  currentSettings: BranchSettings;

  constructor(private location: LocationService,
    private toaster: ToastrService,
    private utilities: UtilitiesService,
    private loader: NgxUiLoaderService,
    private translate: TranslateService,
    private mobileErrorService: InvalidMobileErrorService) { 
    }

    ngOnInit() {
        console.log('locationSettings', this.locationSettings);
    let multiCurrencySetting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_MULTI_CURRENCIES_INBOUND);
    if (multiCurrencySetting != undefined) {
      this.isMultiCurrenciesForInbound = multiCurrencySetting.Value == 'True'
      this.isMultiCurrenciesVisible = multiCurrencySetting.ShownOnUI
    }
    const phoneOptionalSetting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_PHONE_NUMBER_OPTIONAL);
    const emailOptionalSetting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_EMAIL_OPTIONAL);


    this.isPhoneOptionalForInbound = phoneOptionalSetting != undefined ? phoneOptionalSetting.Value == 'True' : false;
    this.isEmailOptionalForInbound = emailOptionalSetting != undefined ? emailOptionalSetting.Value == 'True' : false;

    let autoCashoutSetting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_AUTO_CASHOUT);
    if( autoCashoutSetting != undefined){
      this.ForceDailyCashout = autoCashoutSetting.Value == 'True';
    }
    debugger;
    let TopazSetting = this.locationSettings.find(m => m.Key == SETTING_KEY_FOR_TOPAZ_SIGWEB);
    if( TopazSetting != undefined){
      this.AllowTopazSigWeb = TopazSetting.Value == 'True';
    }

    console.log('AllowTopazSigWeb', this.AllowTopazSigWeb);

    this.currentSettings = {
      isMultiCurrenciesForInbound: this.isMultiCurrenciesForInbound,
      isPhoneOptionalForInbound: this.isPhoneOptionalForInbound,
      isEmailOptionalForInbound: this.isEmailOptionalForInbound,
      ForceDailyCashout: this.ForceDailyCashout,
      AllowTopazSigWeb: this.AllowTopazSigWeb
    }

     console.log('init currentSettings Object', this.currentSettings);
     this.initialSettings = { ...this.currentSettings };
     console.log('init initialSettings Object', this.initialSettings);

    
    this.location.getLocationDetails((res) => {
      this.branchDetails = res;
      this.BusinessWeek = this.branchDetails.BusinessWeek;
    }, (err) => {

    });
    this.location.getPackagingPrices(
      (res) => {
        this.smallPackagingPrice = res.Results[0].Small;
        this.mediumPackagingPrice = res.Results[0].Medium;
        this.largePackagingPrice = res.Results[0].Large;
        
      },
      (err) => {
          console.error('Error fetching packaging prices:', err);
      }
  );

    this.utilities.getCurrencies((res) => {
      this.currencies = res;
    }, (err) => { })
  };

  onSelectCurrency(currency) {
    if (currency) {
      this.branchDetails.BranchCurrencyCode = currency.key;
      this.validatorObject.Currency.valid = true;
      this.validatorObject.Currency.message = '';
    }
    else {
      this.branchDetails.BranchCurrencyCode = "";
      this.validatorObject.Currency.valid = false;
      this.validatorObject.Currency.message = `<i class="armx-icon armx-cancel">${this.translate.instant('pages.branchManagementPage.errors.validCurrencyCode')}</i>`;
    }
  }

  validatorObject = {
    LocalizedName: {
      valid: false,
      message: ''
    },
    Currency: {
      valid: false,
      message: ''
    },
    Mobile: {
      valid: true,
      message: ''
    },
    Fax: {
      valid: true,
      message: ''
    }
  }

  validateSaveObject = {
    valid: true,
    message: ''
  }
  

  validateBranchDetails() {

    var inValidLocalizedName = this.branchDetails.BranchLocalizedDisplayName == "" || this.branchDetails.BranchLocalizedDisplayName == null;
    var inValidCurrency = this.branchDetails.BranchCurrencyCode == "" || this.branchDetails.BranchCurrencyCode == null;

    if (inValidLocalizedName || inValidCurrency || !this.validatorObject.Mobile.valid || !this.validatorObject.Fax.valid) {
      if (inValidLocalizedName) {
        this.validatorObject.LocalizedName.valid = false;
        this.validatorObject.LocalizedName.message = `<i class="armx-icon armx-cancel">${this.translate.instant('pages.branchManagementPage.errors.validlocalName')}</i>`;
      }
      else {
        this.validatorObject.LocalizedName.valid = true;
        this.validatorObject.LocalizedName.message = '';
      }
      if (inValidCurrency) {
        this.validatorObject.Currency.valid = false;
        this.validatorObject.Currency.message = `<i class="armx-icon armx-cancel">${this.translate.instant('pages.branchManagementPage.errors.validCurrencyCode')}</i>`;
      }
      else {
        this.validatorObject.Currency.valid = true;
        this.validatorObject.Currency.message = '';
      }

      if (this.validatorObject.Mobile.valid) {
        this.validatorObject.Mobile.valid = true;
        this.validatorObject.Mobile.message = '';
      }
      else {
        this.validatorObject.Mobile.valid = false;
      }

      if (this.validatorObject.Fax.valid) {
        this.validatorObject.Fax.valid = true;
        this.validatorObject.Fax.message = '';
      }
      
      else {
        this.validatorObject.Fax.valid = false;
      }
      if (this.validatorObject.LocalizedName.valid && this.validatorObject.Currency.valid && this.validatorObject.Mobile.valid && this.validatorObject.Fax.valid) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      this.validatorObject.LocalizedName.valid = true;
      this.validatorObject.LocalizedName.message = '';
      this.validatorObject.Currency.valid = true;
      this.validatorObject.Currency.message = '';

      return true;
    }
  }

  updateBranchDetails() {
    debugger;
    if (this.validateBranchDetails()) {
      this.loader.start();

      const currentSettings: BranchSettings = {
        isMultiCurrenciesForInbound: this.isMultiCurrenciesForInbound,
        isPhoneOptionalForInbound: this.isPhoneOptionalForInbound,
        isEmailOptionalForInbound: this.isEmailOptionalForInbound,
        ForceDailyCashout: this.ForceDailyCashout,
        AllowTopazSigWeb: this.AllowTopazSigWeb
      };

      const changedSettings = Object.keys(currentSettings)
        .filter(key =>
          currentSettings[key] !== this.initialSettings[key]
        )
        .map(key => ({
          key,
          value: currentSettings[key]
        }));

      const payload = {
        location: this.branchDetails,
        changedSettings
      }
      this.location.saveLocationDetails(
        payload,
        (res) => {
          console.log('res', res);
          this.loader.stop();
          this.validateSaveObject.valid = true;
          if (res[0].massage == '') {
            this.validateSaveObject = {
              valid: false,
              message: '<i class="armx-icon armx-cancel"></i> ' + res.errorMessage
            };
            this.updateLocalLocationSetting();
            this.toaster.success(`${this.translate.instant('pages.branchManagementPage.updateBranch')}`);
          }
        },
        (err) => {
          console.log('err', err);
          console.error('Error updating branch details:', err);
          this.loader.stop();
          this.toaster.error(`${this.translate.instant('pages.branchManagementPage.FailedToUpdateBranch')}`);

          if (err.length == 1) {
            if (err[0].Message.includes("Localized")) {
              this.validatorObject.LocalizedName = {
                valid: false,
                message: '<i class="armx-icon armx-cancel"></i> ' + err[0].Message
              };
            }
            this.validateSaveObject = {
              valid: false,
              message: '<i class="armx-icon armx-cancel"></i> ' + err[0].Message
            };
          }
        }
      );

      let userLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
      let userName = JSON.parse(sessionStorage.getItem('user')).FirstName;
      let PackagingPayload = {
        "locationId": userLocationId,
        "small": this.smallPackagingPrice,
        "medium": this.mediumPackagingPrice,
        "large": this.largePackagingPrice,
        "modifiedBy": userName,
        "modifiedOn": new Date()
      }

      this.location.addPackagingPrices(
        PackagingPayload,
        (res) => {
          this.loader.stop();
        }, (err) => {
          console.error(err);
          this.loader.stop();
        }
      );
    }
  }

  updateLocalLocationSetting() {
    if (this.isMultiCurrenciesVisible == false)
      return;

    let oldData = JSON.parse(sessionStorage.getItem('branchSettings'));
    oldData.forEach((i) => {
      if(i.Key == SETTING_KEY_FOR_MULTI_CURRENCIES_INBOUND) {
        i.Value = this.isMultiCurrenciesForInbound ? 'True' : 'False';
      }
      if(i.Key == SETTING_KEY_FOR_PHONE_NUMBER_OPTIONAL) {
        i.Value = this.isPhoneOptionalForInbound ? 'True' : 'False';
      }
      if(i.Key == SETTING_KEY_FOR_EMAIL_OPTIONAL) {
        i.Value = this.isEmailOptionalForInbound ? 'True' : 'False';
      }
      if(i.Key == 13){
        i.Value = this.ForceDailyCashout ? 'True' : 'False';
      }
      if(i.Key == 38){
        i.Value = this.AllowTopazSigWeb ? 'True' : 'False';
      }
    });
    sessionStorage.setItem('branchSettings', JSON.stringify(oldData));
    this.locationSettings = JSON.parse(sessionStorage.getItem('branchSettings'));
  }

  resolvePhone(phoneNumber, fieldType) {
      this.utilities.resolvePhone({
        CountryCode: this.branchDetails.BranchCompanyCountryCode,
        PhoneNumber: phoneNumber
      },
        (res) => {
          if (fieldType == 'phone') {
            this.branchDetails.BranchTelephone = res.PhoneNumber;
            this.validatorObject.Mobile = {
              valid: true,
              message: '',
            }
          } else {
            this.branchDetails.BranchFax = res.PhoneNumber;
            this.validatorObject.Fax = {
              valid: true,
              message: '',
            }
          }
        }, (err) => {
          if (fieldType == 'phone') {
            this.validatorObject.Mobile = {
              valid: false,
              message: '<i class="armx-icon armx-cancel"></i> ' + this.mobileErrorService.getErrorMessage(err),
            }
          } else {
            this.validatorObject.Fax = {
              valid: false,
              message: '<i class="armx-icon armx-cancel"></i> ' + this.mobileErrorService.getErrorMessage(err),
            }
          }
        })
  }

  
}
